var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8272 9.22818H15.8512V6.38818H8.29117V9.22818H6.17117C5.98022 9.22818 5.79708 9.30404 5.66205 9.43907C5.52703 9.57409 5.45117 9.75723 5.45117 9.94818V15.1882C5.45325 15.3785 5.52978 15.5604 5.66435 15.695C5.79893 15.8296 5.98086 15.9061 6.17117 15.9082H8.29117V17.5882H15.8512V15.8762H17.8352C18.0261 15.8762 18.2093 15.8003 18.3443 15.6653C18.4793 15.5303 18.5552 15.3471 18.5552 15.1562V9.94818C18.5552 9.85296 18.5363 9.75867 18.4996 9.67079C18.4629 9.58291 18.4092 9.50318 18.3415 9.43622C18.2738 9.36925 18.1934 9.31639 18.1052 9.28068C18.0169 9.24497 17.9224 9.22713 17.8272 9.22818ZM9.09117 7.18818H15.0512V9.22818H9.09117V7.18818ZM15.0512 16.7882H9.09117V13.8682H15.0512V16.7882ZM17.7552 15.0522H15.8512V13.0682H8.29117V15.0762H6.25117V10.0282H17.7472L17.7552 15.0522Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/PrintIcon.7d2819eeb3275f521d13ca9fcd985e51.svg";
export { ForwardRef as ReactComponent };